export default "__VITE_ASSET__yWRSGfQJ__"